import { optimizedAppearDataAttribute } from './basler-components.es858.js';

function getOptimisedAppearId(visualElement) {
    return visualElement.props[optimizedAppearDataAttribute];
}

export { getOptimisedAppearId };
